import { Vue } from './common/vue'
import { VueSignature } from './common/vue-signature-pad'
require('./components/form/mixins')

window._ = require('./common/lodash').default

import { ConfigProvider, Input, Select, Row, Col, Icon, Button, FormModel, 
  Radio, Checkbox, Form, Spin, message, Badge
} from 'ant-design-vue'

[ConfigProvider,
  Input, Select, Row, Col, Icon, Button, FormModel, 
  Radio, Checkbox, Form, Spin, message, Badge].forEach((c) => {
  Vue.use(c)
})

message.config({ duration: 5, maxCount: 3 })
Vue.prototype.$message = message

import icon from './components/common/icon.vue'
Vue.component('icon', icon)

import WebForm from './components/form.vue'

Vue.use(VueSignature)

new Vue({
  el: '#form',
  render: h => h(WebForm)
})

document.addEventListener('keydown', function (e) {
    if (e.keyCode == 119) { // F8
        debugger;
    }
}, {
    capture: true
});